import { render, staticRenderFns } from "./EpubPage.vue?vue&type=template&id=4289d577"
import script from "./EpubPage.vue?vue&type=script&lang=js"
export * from "./EpubPage.vue?vue&type=script&lang=js"
import style0 from "./EpubPage.vue?vue&type=style&index=0&id=4289d577&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports